import * as React from "react";
import BaseLayout from "../../components/BaseLayout";
import Home from "../../features/Home";
import HomePageFilter from "../../features/Home/HomePageFilter";
import TableNew from "../../components/HomeTableNew";

function HomeScreen() {
  return (
    <BaseLayout paddingTop>
      <HomePageFilter />
      <TableNew />
    </BaseLayout>
  );
}

export default HomeScreen;
